import React from "react";
import { useOutletContext, Link } from "react-router-dom";
import { MapPin, Plus, Users, Package, Truck } from "lucide-react";

export default function BusinessDashboardPage() {
  const { user, customer } = useOutletContext();

  const widgets = [
    { label: "Opret forsendelse", icon: Plus, to: "/business/create", testid: "biz-dash-create", description: "Same Day eller Next Day" },
    { label: "Forsendelser", icon: Package, to: "/business/shipments", testid: "biz-dash-shipments", description: "Se status, tracking, annullér" },
    { label: "Pickup-lokationer", icon: MapPin, to: "/business/pickup-locations", testid: "biz-dash-pickup-locations", description: "Administrér dine pickup-adresser" },
    { label: "Brugere", icon: Users, to: "/business/users", testid: "biz-dash-users", description: "Inviter kolleger til portalen" },
  ];

  return (
    <div className="space-y-8" data-testid="business-dashboard-page">
      <div>
        <div className="text-xs uppercase tracking-wider text-brand-red font-semibold">Dashboard</div>
        <h1 className="font-display font-bold text-3xl text-brand-dark mt-1">Hej, {user?.name || user?.email?.split("@")[0]}</h1>
        <p className="text-sm text-brand-text2 mt-1">Velkommen til EMA Kurer Business Portal for <strong>{customer?.company_name}</strong>.</p>
      </div>

      {/* Coming-soon banner */}
      <div className="bg-amber-50 border border-amber-200 p-4 text-sm" data-testid="biz-dash-coming-soon">
        <div className="font-semibold text-amber-900 mb-1 flex items-center gap-2"><Truck size={16}/> Forsendelses-flow lanceres trinvist</div>
        <p className="text-amber-800">Du kan allerede nu oprette pickup-lokationer og invitere brugere. Forsendelses-oprettelse, CSV-import, labels, tracking, fakturagrundlag og API-adgang lanceres i kommende sub-sprints.</p>
      </div>

      {/* Quick widgets */}
      <div>
        <h2 className="font-display font-bold text-xl text-brand-dark mb-3">Kom i gang</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {widgets.map((w) => (
            <Link key={w.to} to={w.to} data-testid={w.testid}
                  className="bg-white border border-brand p-5 hover:border-brand-red transition-colors">
              <w.icon size={28} className="text-brand-red mb-3"/>
              <div className="font-display font-bold text-lg text-brand-dark">{w.label}</div>
              <div className="text-sm text-brand-text2 mt-1">{w.description}</div>
            </Link>
          ))}
        </div>
      </div>

      {/* Roadmap hint */}
      <div className="bg-white border border-brand p-5">
        <h3 className="font-display font-bold text-lg text-brand-dark mb-2">Hvad kommer snart?</h3>
        <ul className="text-sm text-brand-text2 space-y-1 list-disc list-inside">
          <li>Sub-sprint 2B: Opret forsendelser, tracking events</li>
          <li>Sub-sprint 2C: Labels (10×15cm thermal + A6) + QR + public tracking</li>
          <li>Sub-sprint 2D: CSV/Excel import med validering</li>
          <li>Sub-sprint 2E: Pickup manifester</li>
          <li>Sub-sprint 2F: API integration + webhooks (sandbox + live)</li>
          <li>Sub-sprint 2G: Failed delivery + returns</li>
          <li>Sub-sprint 2H: Invoice basis + control tower</li>
        </ul>
      </div>
    </div>
  );
}
